import Vue from 'vue'
import { Injectable } from '@zhfe/vue2-di-plugin'

/**
 * 桥接类
 */
@Injectable()
export class EventBusService extends Vue {
}
